import React from "react"

// =============================================================================
// Props
// =============================================================================

export type CountBadgeProps = {
  /** The numeric count to display */
  count: number
}

// =============================================================================
// Component
// =============================================================================

/**
 * A compact count chip for displaying numeric values in UI chrome — nav items,
 * list rows, tab headers, etc. Distinct from `Badge`, which is a status label.
 */
export function CountBadge({ count }: CountBadgeProps) {
  return (
    <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-blue-100 px-[6px] text-xs font-semibold text-blue-800">
      {count}
    </span>
  )
}

CountBadge.displayName = "CountBadge"
